import React from 'react';
import {compose} from 'recompose';
import {GoogleMap, Marker, withGoogleMap, withScriptjs} from "react-google-maps"


const Map = compose(
  // withProps({
  //     googleMapURL: "https://maps.googleapis.com/maps/api/js?key=AIzaSyD1wvONHEeeeT7ghz9y-DvewuiHz60iaWw&v=3.exp&libraries=geometry,drawing,places",
  //     loadingElement: <div style={{height: `100%`}}/>,
  //     containerElement: <div style={{height: `600px`}}/>,
  //     mapElement: <div style={{height: `100%`}}/>,
  // }),
  withScriptjs,
  withGoogleMap
)((props) =>
  <GoogleMap
    defaultZoom={props.zoom}
    defaultCenter={{lat: 20, lng: 0}}
  >
      {
          props.latLongArray.map((item, index) => {
             return <Marker key={index} position={{lat: parseInt(item[0]), lng: parseInt(item[1])}}/>
          })
      }

  </GoogleMap>
)

export default Map;


// WEBPACK FOOTER //
// ./src/components/GoogleMap/Map.js